<sew-icon [icon]="icon" size="xl"></sew-icon>
<div class="info-container">
    <sew-link>
        <a href="" (click)="$event.preventDefault(); onSelectService()" [oscTrackClick]="trackClickEvent">
            {{ linkText }}
        </a>
    </sew-link>
    <p class="info">{{ text }}</p>
</div>
